<h1 mat-dialog-title>Välja media</h1>
<div mat-dialog-content
     class="py-2">
  <flow-media [isModal]="true"
                      (mediaSelected)="onSelected($event)"
                      (cancel)="onCancel()"></flow-media>
</div>
